<template>
  <table-ag
    ref="agFrsm"
    :row-data="datos"
    :columnDefs="columns"
    :menu-filter="{ group: 'name', active: true }"
    :typeSelection="limitSelection > 1 ? 'multiple' : 'single'"
    :limitSelection="limitSelection"
    :filters="select(this.filters)"
    :onDeselectEmptyData="true"
    @selected="selected"
  ></table-ag>
</template>

<script>
import tableAg from "../dashboard/tableAg.vue";
export default {
  data() {
    return {
      columns: [
        {
          field: "name",
          hide: true,
          editable: false,
          getQuickFilterText: (params) => {
            return `FILTER_${params.value.replace(" ", "")}_GRUPO`;
          },
        },
        {
          field: "subGrupo",
          headerName: "SubGrupo",
          filter: "agTextColumnFilter",
          editable: false,
          resizable: true,
          checkboxSelection: true,
          showDisabledCheckboxes: true,
          tooltipValueGetter: (params) => {
            return params.value;
          },
        },
        {
          field: "CONSENTIMIENTO",
          headerName: "N",
          valueGetter: (params) => {
            return params.data["CONSENTIMIENTO"]
              ? params.data["CONSENTIMIENTO"][0]["countData"].sum
              : 0;
          },
          filter: "agTextColumnFilter",
          editable: false,
          width: 90,
        },
        {
          field: "RGO-03-LIDERAZGO Y RELACIONES SOCIALES EN EL TRABAJO",
          valueGetter: (params) => {
            return this.valueRange(params);
          },
          headerName: "Liderazgo Y Relaciones Sociales",
          filter: "agTextColumnFilter",
          editable: false,
          cellRenderer: this.valueEmpty,
          cellClass: (params) => this.cellClassRules(params),
          getQuickFilterText: (params) => {
            return "";
          },
          tooltipField: "RGO-03-LIDERAZGO Y RELACIONES SOCIALES EN EL TRABAJO",
          tooltipComponent: "tooltipGraphBarHorizontal",
        },
        {
          field: "RGO-04-CONTROL SOBRE EL TRABAJO",
          headerName: "Control Sobre El Trabajo",
          valueGetter: (params) => {
            return this.valueRange(params);
          },
          filter: "agTextColumnFilter",
          editable: false,
          cellRenderer: this.valueEmpty,
          cellClass: (params) => this.cellClassRules(params),
          getQuickFilterText: (params) => {
            return "";
          },
          tooltipField: "RGO-03-LIDERAZGO Y RELACIONES SOCIALES EN EL TRABAJO",
          tooltipComponent: "tooltipGraphBarHorizontal",
        },
        {
          field: "RGO-05-DEMANDAS DEL TRABAJO",
          headerName: "Demandas Del Trabajo",
          valueGetter: (params) => {
            return this.valueRange(params);
          },
          filter: "agTextColumnFilter",
          editable: false,
          cellRenderer: this.valueEmpty,
          cellClass: (params) => this.cellClassRules(params),
          getQuickFilterText: (params) => {
            return "";
          },
          tooltipField: "RGO-03-LIDERAZGO Y RELACIONES SOCIALES EN EL TRABAJO",
          tooltipComponent: "tooltipGraphBarHorizontal",
        },
        {
          field: "RGO-06-RECOMPENSAS",
          headerName: "Recompensas",
          filter: "agTextColumnFilter",
          valueGetter: (params) => {
            return this.valueRange(params);
          },
          editable: false,
          cellRenderer: this.valueEmpty,
          cellClass: (params) => this.cellClassRules(params),
          getQuickFilterText: (params) => {
            return "";
          },
          tooltipField: "RGO-03-LIDERAZGO Y RELACIONES SOCIALES EN EL TRABAJO",
          tooltipComponent: "tooltipGraphBarHorizontal",
        },
        {
          field: "RGO-02-TOTAL FRP INTRALABORALES",
          headerName: "Total FRP Intralaborales",
          valueGetter: (params) => {
            return this.valueRange(params);
          },
          filter: "agTextColumnFilter",
          editable: false,
          cellRenderer: this.valueEmpty,
          cellClass: (params) => this.cellClassRules(params),
          getQuickFilterText: (params) => {
            return "";
          },
          tooltipField: "RGO-03-LIDERAZGO Y RELACIONES SOCIALES EN EL TRABAJO",
          tooltipComponent: "tooltipGraphBarHorizontal",
        },
      ],
    };
  },
  props: {
    datos: Array,
    filters: {
      type: Array,
      default() {
        return [];
      },
    },
    limitSelection: Number,
  },
  methods: {
    valueEmpty() {
      return "";
    },
    valueRange(params) {
      params = { ...params };
      const rang = {
        "bg-alta": 1,
        "bg-media": 2,
        "bg-destacado": 3,
        "bg-sinrango": 4,
      };
      const currentRang = this.getRange({
        value: params.data[params.colDef.field],
      });

      let result = null;

      result = rang[currentRang];

      return result;
    },
    calculatePorcentage(v, sum) {
      return ((v * 100) / sum).toFixed(1);
    },
    getRange(p) {
      p = p.value;
      if (p) {
        let result = "";
        // Se suma todos los valores
        const sum = p
          .map((x) => {
            if (x.SubGrupo) return x["countData"]["sum"];
            return 0;
          })
          .reduce((a, b) => a + b, 0);

        // Objecto con estructura organizada
        let porcentageGroups = {
          alta1: {
            groups: ["Riesgo alto", "Riesgo muy alto"],
            sum: 0,
          },
          media: {
            groups: ["Riesgo medio", "Riesgo alto", "Riesgo muy alto"],
            sum: 0,
          },
          destacado: {
            groups: [
              "Sin riesgo o riesgo despreciable",
              "Riesgo bajo",
              "Sin riesgo o riesgo bajo",
              "Factor protector",
            ],
            sum: 0,
          },
        };

        // Se saca la suma para la estrucutura solicitada
        p.map((e) => {
          const sub = !e.SubGrupo ? "" : String(e.SubGrupo);

          if (porcentageGroups.alta1["groups"].includes(sub)) {
            porcentageGroups.alta1.sum += parseFloat(
              this.calculatePorcentage(e["countData"]["sum"], sum)
            );
          }
          if (porcentageGroups.media["groups"].includes(sub)) {
            porcentageGroups.media.sum += parseFloat(
              this.calculatePorcentage(e["countData"]["sum"], sum)
            );
          }
          if (porcentageGroups.destacado["groups"].includes(sub)) {
            porcentageGroups.destacado.sum += parseFloat(
              this.calculatePorcentage(e["countData"]["sum"], sum)
            );
          }
        });

        // Se calcula el porcentage para cada elemento del objeto anterior y retornar un rango
        for (const k in porcentageGroups) {
          const porcentage = porcentageGroups[k]["sum"];
          if (k === "alta1" && porcentage >= 30.0) {
            result = "bg-alta";
            break;
          } else if (k === "media" && porcentage >= 40.0) {
            result = "bg-media";
            break;
          } else if (k === "destacado" && porcentage >= 60.0) {
            result = "bg-destacado";
            break;
          } else if (porcentage < 30.0) {
            result = "bg-sinrango";
          }
        }
        return result;
      }
      return "bg-sinrango";
    },
    cellClassRules(p) {
      p = p.value;
      if (p) {
        const rang = {
          1: "bg-alta",
          2: "bg-media",
          3: "bg-destacado",
          4: "bg-sinrango",
        };
        return rang[p];
      }
      return "bg-sinrango";
    },
    selected(i) {
      this.$emit("setFilterTable", i);
    },
    deselect() {
      this.$refs.agFrsm.deselectAll();
    },
    deselectOne(filter) {
      filter = filter.map((x) => {
        return { name: x.gr.split("AGR-")[1], subGrupo: x.subgr };
      });
      this.$refs.agFrsm.deselectOne(filter);
    },
    select(filter) {
      if (filter && filter.length) {
        return filter.map((x) => {
          return { name: x.gr.split("AGR-")[1], subGrupo: x.subgr };
        });
      } else {
        return null;
      }
    },
  },
  created() {},
  components: {
    tableAg,
  },
};
</script>
<style lang="scss">
// Range 2
.bg-altaTable {
  background-color: #f4cdcd;
  border: solid 1px #f6adad;
}
.bg-mediaTable {
  background-color: #fff2cc;
  border: solid 1px #f6db8a;
}
.bg-destacadoTable {
  background-color: #d9ead3;
  border: solid 1px #c3eab5;
}
.bg-sinrangoTable {
  background-color: #eceeec;
  border: solid 1px #d4d5d3;
}
</style>



// WEBPACK FOOTER //
// src/components/frpm/table.vue